import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const CustomerDetailPage = lazy(() => import('@/pages/customers/detail'));

export const Route = createFileRoute('/customers/$id')({
  component: function CustomerRoute() {
    const { id } = Route.useParams();
    return (
      <Suspense fallback={<TableSkeleton />}>
        <CustomerDetailPage customerId={id} />
      </Suspense>
    );
  },
});
